export const giftCardPoolReport = {
  amountByLocationList: [
    {
      locationId: 'f30af988-e209-4036-9a81-44d077f035e3',
      locationName: 'Fenway -Toast IncPay',
      amount: 50.97,
      noOfRecords: 5,
    },
    {
      locationId: '5d69f9ee-5628-4b64-98f7-685e425d63a1',
      locationName: 'Incentivio Payments',
      amount: -43.0,
      noOfRecords: 2,
    },
    {
      locationId: '83e264cd-1ab2-4433-b954-726bce5d002d',
      locationName: 'Incentivio Payments 2',
      amount: -24.2,
      noOfRecords: 14,
    },
    {
      locationId: '83a99d9e-395a-4c06-a8ba-e25dc8c52157',
      locationName: 'Isuru Store',
      amount: 0,
      noOfRecords: 0,
    },
    {
      locationId: '90641054-a6b4-44cd-a677-d0c921fbaf1b',
      locationName: 'Mat Test Store',
      amount: 0,
      noOfRecords: 0,
    },
    {
      locationId: '4ead8289-9007-43d8-aa4c-df6e4d332fd6',
      locationName: 'QA store 01  Central time',
      amount: 0,
      noOfRecords: 0,
    },
    {
      locationId: 'c6f85731-2c29-4ecd-95bc-f3b60c73aad4',
      locationName: 'Test Hesh',
      amount: 0,
      noOfRecords: 0,
    },
  ],
  amountByPoolAccount: {
    amount: 2517.0,
    noOfRecords: 50,
  },
  amountByBonusAccount: {
    amount: 20.0,
    noOfRecords: 0,
  },
};

export const giftCardPoolReportWithZeroAmount = {
  amountByLocationList: [
    {
      locationId: 'f30af988-e209-4036-9a81-44d077f035e3',
      locationName: 'Fenway -Toast IncPay',
      amount: 0,
      noOfRecords: 0,
    },
    {
      locationId: '5d69f9ee-5628-4b64-98f7-685e425d63a1',
      locationName: 'Incentivio Payments',
      amount: 0,
      noOfRecords: 0,
    },
  ],
  amountByPoolAccount: {
    amount: 0.0,
    noOfRecords: 0,
  },
  amountByBonusAccount: {
    amount: 0.0,
    noOfRecords: 0,
  },
};
